import React from 'react';
import cx from 'classnames';

const FormInputCorrectMessage = props => {
  const {
    isLoginModal,
    value,
  } = props;

  const formInputCorrectMessageClass = cx ('Icon Icon--check', {
    'FormInput-correct-LoginModal': isLoginModal,
    'FormInput-correct': !isLoginModal,
  });

  return value && <span className={ formInputCorrectMessageClass } /> ;
};

FormInputCorrectMessage.defaultProps = {
  isLoginModal: false,
};

export default FormInputCorrectMessage;
